import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { NAV_LINKS, SITE } from "@/content/site";
import { Wordmark } from "@/components/site/Wordmark";
import { PhoneValue } from "@/components/site/Bits";

const ColTitle = ({ children }) => <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">{children}</h2>;

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/[0.08]" data-testid="site-footer">
    <div className="container-x grid gap-12 py-16 md:grid-cols-12 lg:py-20">
      <div className="space-y-4 md:col-span-4">
        <Wordmark testId="footer-wordmark" />
        <p className="max-w-xs text-sm leading-relaxed text-[#A1A1AA]">{SITE.tagline}</p>
      </div>
      <div className="md:col-span-2">
        <ColTitle>Pages</ColTitle>
        <ul className="mt-5 space-y-3 text-sm">
          {[{ to: "/", label: "Home" }, ...NAV_LINKS].map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className="text-white/80 transition-colors hover:text-white"
                data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-3">
        <ColTitle>Contact</ColTitle>
        <ul className="mt-5 space-y-3 text-sm text-white/80">
          <li className="flex items-center gap-2.5">
            <Mail className="h-4 w-4 shrink-0 text-[#2F6BFF]" aria-hidden="true" />
            <a href={`mailto:${SITE.email}`} className="hover:text-white" data-testid="footer-email-link">
              {SITE.email}
            </a>
          </li>
          <li className="flex items-center gap-2.5">
            <Phone className="h-4 w-4 shrink-0 text-[#2F6BFF]" aria-hidden="true" />
            <PhoneValue testId="footer-phone" />
          </li>
        </ul>
      </div>
      <div className="md:col-span-3">
        <ColTitle>Service area</ColTitle>
        <p className="mt-5 flex gap-2.5 text-sm leading-relaxed text-white/80" data-testid="footer-service-area">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#2F6BFF]" aria-hidden="true" />
          {SITE.serviceArea}
        </p>
      </div>
    </div>
    <div className="container-x flex flex-col justify-between gap-2 border-t border-white/[0.08] py-6 text-xs text-[#A1A1AA] sm:flex-row">
      <p>© {new Date().getFullYear()} ATA Forge. All rights reserved.</p>
      <p>Designed and built in Wayne, NJ.</p>
    </div>
    <div
      aria-hidden="true"
      className="pointer-events-none select-none overflow-hidden whitespace-nowrap px-4 text-center text-[17vw] font-semibold leading-[0.78] tracking-[-0.06em]"
    >
      <span className="bg-gradient-to-b from-white/[0.09] to-transparent bg-clip-text text-transparent">ATA Forge</span>
    </div>
  </footer>
);
